
import { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';

import LogoHeader from '../Assets/Image/trident-logo.jpg'
import '../Assets/Css/webheader.css';
import { FaUsers, FaBuilding, FaRocket, FaUserTie, FaLaptopCode, FaEnvelopeOpenText,FaShoppingCart } from 'react-icons/fa';

import { FaHome, } from 'react-icons/fa';

function WebHeader() {

    const [showSidebar, setShowSidebar] = useState(false);
    const [navbarSolid, setNavbarSolid] = useState(false);

    const handleClose = () => setShowSidebar(false);
    const handleShow = () => setShowSidebar(true);
    const [topHeaderScrolled, setTopHeaderScrolled] = useState(false);

    //     useEffect(() => {
    //     const handleScroll = () => {
    //         const scrollTop = window.scrollY;
    //         setNavbarSolid(scrollTop > window.innerHeight - 200);
    //         setTopHeaderScrolled(scrollTop > 0); 
    //     };

    //     window.addEventListener('scroll', handleScroll);
    //     return () => window.removeEventListener('scroll', handleScroll);
    // }, []);


    // useEffect(() => {
    //     const handleScroll = () => {
    //         const scrollTop = window.scrollY;
    //         const bannerHeight = 0.7 * window.innerHeight; 
    //         setNavbarSolid(scrollTop > bannerHeight - 200); 
    //         setTopHeaderScrolled(scrollTop > 0);
    //     };

    //     window.addEventListener('scroll', handleScroll);
    //     return () => window.removeEventListener('scroll', handleScroll);
    // }, []);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            const isMobile = window.innerWidth <= 768; // Adjust breakpoint as needed
            const bannerHeight = isMobile ? 0.7 * window.innerHeight : window.innerHeight;

            setNavbarSolid(scrollTop > bannerHeight - 200);
            setTopHeaderScrolled(scrollTop > 0);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    const navigate = useNavigate();


    return (
        <>
            {/* <div className={`top-header ${topHeaderScrolled ? 'top-header-scrolled' : ''}`}>
                <Container className="d-flex justify-content-between align-items-center">
                    <div className="d-flex email-info">
                        <a href="#" target="_blank" rel="noopener noreferrer"
                            className="text-white" style={{ textDecoration: 'none' }}>
                            <FaPhoneSquareAlt /> +1 (312) 284-7077
                        </a>
                        <span className='mx-2 text-white'> | </span>
                        <a href="mailto: tridentsoftwares@gmail.com"
                            className="d-flex text-white align-items-center gap-2" style={{ textDecoration: 'none' }}>
                            <MdMarkEmailRead />
                            info@tridentsoftwareservice.com
                        </a>
                    </div>
                    <div className='d-none d-md-flex'>
                        <a className='icontop' href="#">
                            <FaFacebookF />
                        </a>
                        <a className='icontop mx-2' href='#'>
                            <IoLogoYoutube />
                        </a>
                    </div>
                </Container>
            </div> */}

            <Navbar expand="lg" className={`custom-navbar ${navbarSolid ? 'navbar-solid scrolled' : 'navbar-transparent'}`}>

                {/* <Container className="d-flex justify-content-between align-items-center"> */}
                   <Container fluid className="d-flex justify-content-between align-items-center px-3 px-lg-5">

                    <Navbar.Brand>
                        <span onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
                            <img
                                src={LogoHeader}
                                alt="Logo"
                                className={`navbar-logo ${navbarSolid ? "scrolled" : ""}`}
                            />
                        </span>
                    </Navbar.Brand> 
                    <Navbar.Toggle aria-controls="offcanvasNavbar" onClick={handleShow} className="d-lg-none" />
                    <Navbar.Collapse id="basic-navbar-nav" className="justify-content-center d-none d-lg-flex">
                        <Nav>
                            <Nav.Link as={NavLink} to="/" onClick={handleClose}>Home</Nav.Link>
                            <Nav.Link as={NavLink} to="/diversity" onClick={handleClose}>Diversity</Nav.Link>
                            <Nav.Link as={NavLink} to="/enterprise" onClick={handleClose}>Enterprise</Nav.Link>
                            <Nav.Link as={NavLink} to="/startups" onClick={handleClose}>Startups</Nav.Link>
                            <Nav.Link as={NavLink} to="/consultants" onClick={handleClose}>Consultants</Nav.Link>
                            <Nav.Link as={NavLink} to="/ourproducts" onClick={handleClose}>Products and Training</Nav.Link>
                           <Nav.Link as={NavLink} to="/ecommerce" onClick={handleClose}>E-Commerce</Nav.Link>
                            <Nav.Link as={NavLink} to="/contact" onClick={handleClose}>Contact</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>

            <Offcanvas show={showSidebar}
                onHide={handleClose}
                placement="start"
                className="custom-offcanvas"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>
                        <img src={LogoHeader} alt="Logo" className="navbar-logo" />
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className='offcanvasbody'>
                    <Nav className="flex-column">
                        <Nav.Link as={NavLink} to="/" onClick={handleClose}>
                            <FaHome size={18} className="me-2" /> Home
                        </Nav.Link>
                        <Nav.Link as={NavLink} to="/diversity" onClick={handleClose}>
                            <FaUsers size={18} className="me-2" /> Diversity
                        </Nav.Link>
                        <Nav.Link as={NavLink} to="/enterprise" onClick={handleClose}>
                            <FaBuilding size={18} className="me-2" /> Enterprise
                        </Nav.Link>
                        <Nav.Link as={NavLink} to="/startups" onClick={handleClose}>
                            <FaRocket size={18} className="me-2" /> Startups
                        </Nav.Link>
                        <Nav.Link as={NavLink} to="/consultants" onClick={handleClose}>
                            <FaUserTie size={18} className="me-2" /> Consultants
                        </Nav.Link>
                        <Nav.Link as={NavLink} to="/ourproducts" onClick={handleClose}>
                            <FaLaptopCode size={18} className="me-2" /> Products & Training
                        </Nav.Link>
                         <Nav.Link as={NavLink} to="/ecommerce" onClick={handleClose}>
                            <FaShoppingCart size={18} className="me-2" /> E-Commerce
                        </Nav.Link>
                        <Nav.Link as={NavLink} to="/contact" onClick={handleClose}>
                            <FaEnvelopeOpenText size={18} className="me-2" /> Contact
                        </Nav.Link>
                    </Nav>
                </Offcanvas.Body>
            </Offcanvas>

        </>
    );
}

export default WebHeader;
